module.exports = __webpack_public_path__ + "static/media/logo_noa-07.abe450b3.svg";